import calculateTransform from './calculateTransform';
export default function (enabledElement) {
    return calculateTransform(enabledElement);
}
